import Generator from '../../../Generator'
import Types from '../../../../actions/Types'

export default Generator.node({
  baseType: Types.DIAMETERS,
  nodeType: Generator.NODETYPE.GET
})



// WEBPACK FOOTER //
// ./src/reducers/root/entities/diameters/get.js